export const BINGO_SCHEDULER = 'bingoscheduler';
export const PAGE_SIZE = 40;
export const GAMES_UPDATE_INTERVAL_MS = 180000;

export const LOBBY_NAME_MAP: Record<string, 'MobileBingoHTML5' | 'TabletBingo' | 'DesktopBingo'> = {
    mobile: 'MobileBingoHTML5',
    tablet: 'TabletBingo',
    desktop: 'DesktopBingo'
};
